module.exports = __webpack_public_path__ + "3c0785055fcb39448525600024078789.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-user/unshare-shared-notes/unshare-shared-notes.html
// module id = 2227
// module chunks = 0